import script from "./BulkEditListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkEditListItem.vue?vue&type=script&setup=true&lang=js"

import "./BulkEditListItem.vue?vue&type=style&index=0&id=10c22787&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c22787"]])

export default __exports__